var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 8.41716V5.15942H10.4922",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3276 1.79688H15.6698C16.5648 1.79688 17.2904 2.61263 17.2904 3.61979V16.3802C17.2904 17.3874 16.5648 18.2031 15.6698 18.2031H4.3276C3.43255 18.2031 2.70703 17.3874 2.70703 16.3802V3.61979C2.70703 2.61263 3.43255 1.79688 4.3276 1.79688Z",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 12.1245H13.7347",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 15.0437H9.99819",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7384 5.15942L10.2004 8.69738L7.90022 7.1678L6.21875 8.84921",
    stroke: "currentColor",
    strokeWidth: 1.6625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgGraph;